import axios from "axios";
import i18next from 'i18next'

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// If the short-lived access token expires while the CRM is open,
// renew it using the HttpOnly refresh cookie and retry the request once.
let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;

    if (
      error.response?.status !== 401 ||
      !original ||
      original._authRetry ||
      original.url?.includes("/auth/refresh")
    ) {
      return Promise.reject(error);
    }

    original._authRetry = true;

    try {
      if (!refreshPromise) {
        refreshPromise = axios.post(
          `${API}/auth/refresh`,
          {},
          { withCredentials: true }
        ).finally(() => {
          refreshPromise = null;
        });
      }

      await refreshPromise;
      return api(original);
    } catch (refreshError) {
      return Promise.reject(refreshError);
    }
  }
);

export function fileUrl(id) {
  return `${API}/files/${id}/download`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return i18next.t('somethingWentWrongPleaseTryAgain', 'Something went wrong. Please try again.');
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
